<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-02 14:55:07
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-15 19:46:50
-->
<template>
	<div>
		<el-drawer
			title="交接业务"
			:visible.sync="drawer"
			class="handover"
			:wrapperClosable="false"
			:before-close="handleClose"
			ref="drawer"
			size="800px"
			custom-class="drawer-wrapper"
			append-to-body
		>
			<div class="p-16">
				<Tip class="mb-16" type="warning"> 交接业务前产生的业绩不会归属为新的交接人</Tip>
				<div class="content pt-20">
					<div class="title-line pb-18 yx-pingfang-Medium"> 选择交接对象 </div>
					<div class="tab">
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabArr" :key="index"></el-tab-pane>
						</el-tabs>
					</div>

					<tobeHanded
						ref="tobeHanded"
						:user_id="user_id"
						@selectionChange="selectionChange"
						@changeSelectAll="changeSelectAll"
						v-if="tobeHand"
						@returnActive="returnActive"
					/>
					<Handover ref="Handover" :user_id="user_id" @seeDetails="seeDetails" v-else />
				</div>
			</div>

			<div class="footer yx-background-white flex-row-align-center flex-just-between">
				<div class="font-h4-regular yx-color-text-primary">
					<template v-if="tobeHand">
						<!-- <el-checkbox v-model="allChecked" @change="checkAllClick">全选</el-checkbox> -->
						<span class="ml-20"
							>已选 <span style="font-weight: 700" class="color-p-4">{{ selectCount }}</span> 个{{ selectName }}</span
						>
					</template>
				</div>
				<div>
					<el-button @click="handleClose">{{ tobeHand ? '取 消' : '关 闭' }}</el-button>
					<el-button type="primary" @click="next" :disabled="isDisabled" v-if="tobeHand">下一步</el-button>
				</div>
			</div>
		</el-drawer>
		<handover-details ref="handoverDetails" />
		<select-handover ref="selectHandover" @refresh="refresh" />
	</div>
</template>

<script>
import tobeHanded from './tobeHanded';
import Handover from './Handover';
import handoverDetails from '../handoverDetails';
import selectHandover from '../selectHandover';
export default {
	components: {
		tobeHanded,
		Handover,
		handoverDetails,
		selectHandover,
	},
	computed: {
		tobeHand({ activeName }) {
			return activeName === 'tobeHanded';
		},
		isDisabled({ selectList }) {
			return !selectList.length;
		},
		selectCount({ selectAll, selectTotal, selectList }) {
			return selectAll ? selectTotal : selectList.length;
		},
	},
	data() {
		return {
			drawer: false,
			roleType: [],
			activeName: 'tobeHanded',
			tabArr: [
				{ label: '待交接', name: 'tobeHanded' },
				{ label: '已移交', name: 'Handover' },
			],
			selectList: [],
			handoverType: 1,
			user_id: '',
			allChecked: false,
			selectTotal: 0,
			selectName: '达人',

			selectAll: false,
		};
	},

	props: {},

	created() {},

	methods: {
		show({ id }) {
			this.user_id = id;
			this.drawer = true;
			this.$nextTick(() => {
				this.$refs.tobeHanded.init();
			});
		},

		handleClick() {
			const { tobeHand } = this;
			this.allChecked = false;
			this.$nextTick(() => {
				if (tobeHand) {
					this.$refs.tobeHanded.init();
				} else {
					this.$refs.Handover.init();
				}
			});
		},
		changeSelectAll(val) {
			this.selectAll = val;
		},
		selectionChange(val, selectTotal = 0) {
			this.selectTotal = selectTotal;
			this.selectList = val;
		},
		seeDetails(row) {
			this.$refs.handoverDetails.show(row);
		},
		next() {
			const { selectAll, user_id, selectTotal } = this;
			this.$refs.selectHandover.show({
				type: this.handoverType,
				selectTodoList: this.selectList,
				from_user_id: user_id,
				selectAll,
				selectTotal,
			});
		},
		returnActive(e) {
			this.allChecked = false;
			this.handoverType = e;
			let obj = {
				1: '达人',
				2: '团长',
				3: '商品',
			};
			this.selectName = obj[e];
		},
		checkAllClick() {
			this.$refs.baseTable.toggleAllSelection();
		},
		refresh() {
			this.$nextTick(() => {
				this.$refs.tobeHanded.init();
			});
		},
		handleClose() {
			if (this.tobeHand) this.$refs.tobeHanded.reset();
			this.activeName = 'tobeHanded';
			this.allChecked = false;
			this.selectList = [];
			this.handoverType = 1;
			this.selectName = '达人';
			this.drawer = false;
		},
	},
};
</script>
<style lang="less" scoped>
.title-line {
	color: @color-gy9;
	font-size: 16px;
	position: relative;
	padding-left: 10px;

	&::before {
		position: absolute;
		content: ' ';
		width: 3px;
		height: 17px;
		background: @color-primary;
		left: 0px;
		top: 3px;
		border-radius: 100px;
	}
}
.handover {
	/deep/ .el-drawer__header span {
		font-size: 14px;
	}
	.content {
		position: relative;
		padding: 0px 20px 0px 20px;
		margin-bottom: 52px;
		background: #fff;
		border-radius: 8px;
	}

	.footer {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		border-top: 1px solid #f0f1f5;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.06);
		z-index: 999;
	}
}
</style>
<style lang="less">
.drawer-wrapper {
	.el-drawer__body {
		background: #f7f8f9;
	}
}
</style>